<template>
  <component
    :is="windowWidth > 1024 ? 's-modal' : 's-bottom-sheet'"
    cluster="k"
    :value="value"
    title="Ubah Email"
    expanded
    @close="handleCloseModal()"
  >
    <template #header>
      <!-- custom header for bottomsheet -->
      <div class="mobile-only mobile-heading">
        <img
          id="mobile-back-btn"
          src="https://cdn.karier.mu/assets/v3/icon/arrow-left.svg"
          alt="arrow-left"
          @click="handleCloseModal()"
        >
        <p class="font-label-xl-sb header-title">
          Ubah Email
        </p>
      </div>
    </template>
    <template #default>
      <div class="editor-wrapper">
        <div class="font-paragraph-5 change-email-title">
          Pastikan email yang Anda masukkan sudah benar. Kode verifikasi akan dikirimkan ke email yang baru.
        </div>
        <s-input
          cluster="k"
          v-model="email"
          label="Email"
          autocomplete="off"
          :error="errorMessage"
        ></s-input>
      </div>
    </template>
    <template #footer>
      <!-- custom footer for bottomsheet and modal -->
      <div class="button-container">
        <s-button
          id="modal-submit-button"
          cluster="k"
          size="small"
          :loading="isLoading"
          :disabled="isDisableSubmit"
          @click="handleSubmit()"
        >
          Kirim
        </s-button>
      </div>
    </template>
  </component>
</template>

<script>
import { mapState } from 'vuex'
import REGEX from '@/constants/regex.js'
import ResizeListener from '@/mixins/resizeListener.js'

export default {
  name: 'ChangeEmailModal',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      email: '',
      isLoading: false,
      errorMessage: ''
    }
  },
  mixins: [ResizeListener],
  computed: {
    ...mapState('storage', ['accessToken']),
    ...mapState('user', ['userInfo']),
    isDisableSubmit () {
      return !this.email
    }
  },
  methods: {
    handleCloseModal () {
      this.$emit('close')
    },
    async handleSubmit () {
      this.errorMessage = ''
      if (this.email === this.userInfo.email) {
        this.errorMessage = 'Email ini sudah terdaftar di akun Anda sekarang.'
        return
      }

      if (!(REGEX.EMAIL.test(String(this.email).toLowerCase()))) {
        this.errorMessage = 'Pastikan format email yang Anda masukan sudah benar.'
        return
      }

      try {
        this.isLoading = true
        const data = await this.$store.dispatch('user/saveEditedProfile', {
          id: this.userInfo.id,
          email: this.email
        })

        if (data.status === 200) {
          this.$store.dispatch('snackbar/showSnackbar', {
            allowMultiple: false,
            text: 'Email berhasil diubah.'
          })
          this.handleCloseModal()
        } else {
          throw data
        }
      } catch (error) {
        switch (error.alertMessage.toLowerCase()) {
          case 'email telah terdaftar':
            this.errorMessage = 'Email ini sudah terdaftar.'
            break

          default:
            this.errorMessage = error.alertMessage
            break
        }
      } finally {
        this.isLoading = false
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        if (val) {
          this.email = this.userInfo.email
          this.errorMessage = ''
        }
      }
    }
  }
}
</script>

<style scoped>
@import url('../../styles/profile.css');

.change-email-title {
  margin-bottom: 16px;
  color: var(--color-text-primary);
}

.button-container ::v-deep .k-button {
  width: 100%;
}

.mobile-heading {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: left;
  left: 0px;
  width: 100%;
  background-color: var(--color-neutral-100);
}

.mobile-heading .header-title {
  margin: 0;
  color: var(--color-text-primary);
  text-transform: capitalize;
}

::v-deep .s-input-label {
  text-transform: capitalize;
}

::v-deep .s-modal-close-icon {
  top: -10px !important;
}
</style>
